import { render } from "./training-type-modal.vue?vue&type=template&id=642d0124"
import script from "./training-type-modal.vue?vue&type=script&lang=js"
export * from "./training-type-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__